import {useState, useEffect, useContext} from 'react';
import {Select} from 'antd';
import services from 'services';
import {AuthContext} from 'context/Auth.context';

const SelectField = (props: any) => {
	const {
		value,
		dictionaryApiPath,
		options: _options,
		customApiFetch = {path: '', labelKey: '', valueKey: ''},
		hiddenOptions,
		disableIfOptionsLength,
		fetchId,
		...rest
	} = props;
	const [options, setOptions] = useState(_options || []);
	const {
		state: {student}
	} = useContext(AuthContext);
	const role = student ? 'STUDENT' : 'CANDIDATE';

	const newValue = Array.isArray(value)
		? value.map(el => el.id || el)
		: !options.length && value
		? null
		: value;

	useEffect(() => {
		if (customApiFetch.path) {
			const newPath = fetchId ? customApiFetch.path + fetchId : customApiFetch.path;

			services.SETTINGS.getByCustomPath(newPath).then(res => {
				setOptions(() => {
					const data = (res.data || res)?.map((opt: any) => ({
						label:
							typeof customApiFetch.labelKey === 'function'
								? customApiFetch.labelKey(opt)
								: opt[customApiFetch.labelKey],
						value: opt[customApiFetch.valueKey]
					}));

					return data;
				});
			});
		} else if (dictionaryApiPath) {
			services.SETTINGS.fetchOptions(dictionaryApiPath, role).then(res => {
				const filterRes = hiddenOptions?.length
					? res.filter(el => !hiddenOptions.includes(el.id))
					: res;
				setOptions(() => {
					const data = filterRes.map(opt => ({
						label: opt.name,
						value: opt.id
					}));

					return data;
				});
			});
		}
	}, [dictionaryApiPath, fetchId]);
	return (
		<Select
			{...rest}
			options={options}
			value={newValue}
			disabled={rest?.disabled || (disableIfOptionsLength && !options?.length)}
			showSearch
			filterOption={(input, option: any) =>
				option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
			}
		/>
	);
};

export default SelectField;
